import { put, take } from "redux-saga/effects";

import { createHideLoadingIndicatorAction, createLoadUserInfoAction, createShowLoadingIndicatorAction, USER_INFO_LOADED } from "@multiweb/reactCore/bridge";
import { createSetFetchingAction } from "@multiweb/reactCore/fetching";
import { SagaWithReturnType } from "@multiweb/types/react";
import { FETCHING_KEY_USER } from "./constants";

export const saga: SagaWithReturnType = function* authSaga() {
    yield put(createShowLoadingIndicatorAction());
    yield put(createSetFetchingAction(FETCHING_KEY_USER, true));
    yield put(createLoadUserInfoAction());
    yield take(USER_INFO_LOADED);
    yield put(createSetFetchingAction(FETCHING_KEY_USER, false));
    yield put(createHideLoadingIndicatorAction());
};
